<template>
  <div class="fundamentos-page">
    <div class="fundamentos-container">
      <!-- Lado Esquerdo - Imagens Sobrepostas -->
      <div class="images-side">
        <StackedImages :images="Images" />
      </div>

      <!-- Lado Direito - Texto Exatamente como na Imagem -->
      <div class="text-side">
        <h1>FUNDAMENTOS</h1>
        <div class="fundamentos-text">
          <p>O fundamento básico do nosso terreiro é tratar a todos com RESPEITO.</p>
          <p>Ter AMOR para com o próximo, e acima de tudo, ensinar com amor.</p>
          <p>Crer na força divina das entidades, ter FÉ mesmo durante os momentos mais difíceis.</p>
          <p>Acreditar que dias de alegria virão.</p>
          <p>Oferecer a mão àqueles que precisam. É ajudar e ser ajudado.</p>
          <p>É ter UNIÃO.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StackedImages from './StackedImages.vue'
export default {
  name: 'FundamentosPage',
  components:{
    StackedImages
  },
  data() {
    return{
        Images:[
            { src: require('@/assets/fundamentos_01.jpg'), alt: 'Gira no Templo EDEM' },
            { src: require('@/assets/fundamentos_02.jpg'), alt: 'Gira no Templo EDEM' },
            { src: require('@/assets/fundamentos_03.jpg'), alt: 'Gira no Templo EDEM' },
            { src: require('@/assets/fundamentos_04.jpg'), alt: 'Gira no Templo EDEM' },
        ]
    }
  },
  mounted() {
    console.log('FundamentosPage component mounted');
  }
};
</script>

<style scoped>
.fundamentos-page {
  padding: 2rem;
  background-color: #ffefbc;
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.fundamentos-container {
  display: flex;
  max-width: 1200px;
  width: 100%;
  gap: 4rem;
  align-items: center; /* Alinha verticalmente no centro */
  justify-content: center;
}

/* Lado das Imagens */
.images-side {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 400px;
}


/* Lado do Texto */
.text-side {
  flex: 1;
  max-width: 500px;
}

h1 {
  font-family: 'Abhaya Libre', serif;
  font-size: 3.5rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 2rem;
  text-align: left;
}

.fundamentos-text {
  text-align: left;
}

.fundamentos-text p {
  font-family: 'Amiri', serif;
  font-size: 1.3rem;
  line-height: 1.0;
  margin-bottom: 1.2rem;
  color: #000;
}

/* Palavras em destaque mantendo o texto original */
.fundamentos-text p strong {
  color: #0a5162;
}

/* ========== VERSÃO MOBILE ========== */
@media (max-width: 921px) {
  .fundamentos-page {
    padding: 1rem;
    min-height: auto;
    padding-top: 80px; /* Compensa a barra superior fixa */
  }

  .fundamentos-container {
    flex-direction: column;
    gap: 2rem;
    align-items: center;
  }

  .images-side {
    order: 1; /* Imagens primeiro no mobile */
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .stacked-images {
    width: 280px;
    height: 370px;
  }

  .image-1,
  .image-2,
  .image-3 {
    width: 230px;
    height: 300px;
  }

  .image-1 {
    top: 0;
    left: 0;
    transform: rotate(-3deg);
  }

  .image-2 {
    top: 30px;
    left: 20px;
    transform: rotate(1deg);
  }

  .image-3 {
    top: 60px;
    left: 40px;
    transform: rotate(2deg);
  }

  .text-side {
    order: 2; /* Texto depois das imagens no mobile */
    max-width: 100%;
    text-align: center;
  }

  h1 {
    font-size: 2.8rem;
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .fundamentos-text p {
    font-size: 1.2rem;
    line-height: 1.7;
    text-align: center;
  }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 480px) {
  .fundamentos-page {
    padding-top: 70px;
  }
  
  h1 {
    font-size: 2.3rem;
  }
  
  .fundamentos-text p {
    font-size: 1.1rem;
  }
  
  .stacked-images {
    width: 250px;
    height: 330px;
  }
  
  .image-1,
  .image-2,
  .image-3 {
    width: 200px;
    height: 260px;
  }
}

/* Versão Desktop Pequena */
@media (min-width: 922px) and (max-width: 1100px) {
  .fundamentos-container {
    gap: 3rem;
    max-width: 1000px;
  }
  
  .stacked-images {
    width: 280px;
    height: 370px;
  }
  
  .image-1,
  .image-2,
  .image-3 {
    width: 230px;
    height: 300px;
  }
  
  h1 {
    font-size: 3rem;
  }
  
  .fundamentos-text p {
    font-size: 1.2rem;
  }
}
</style>